(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-legal-links"] && !Shopify.designMode) return;
  try {
    const cookieSettingsLinks = document.querySelectorAll('[href="#cookie-settings"], [href="#cookieSettings"]');


      if (!cookieSettingsLinks.length) {
        return;
      }
      
      if (!window.concord && cookieSettingsLinks.length > 0) {
        cookieSettingsLinks.forEach(link => {
          link.style.display = 'none';
        });
      }

      if (window.concord && cookieSettingsLinks.length > 0) {
        cookieSettingsLinks.forEach(link => {
          link.addEventListener('click', function(event) {
            event.preventDefault();
            if (window.concord) {
              window.dispatchEvent(new CustomEvent("concord-widget-toggle-consent"))
            }
          });
        });
      }
  } catch(e) { console.error(e); }
})();

})();
